import { useEffect, useState } from 'react';
import Card from '@src/modules/performance/components/Card';
import {
  Text, HStack,
  Wrap,
  Box,
} from '@chakra-ui/react';
import { COLOURS } from '../shared/MapColours';

function MapLegend({ selection, filter, ...props }) {
  const [items, setItems] = useState([]);
  const [colours, setColours] = useState([]);

  useEffect(() => {
    switch (selection) {
      case 'safety':
        setItems([
          'Decreasing trend of 1% or greater',
          'Between a 1% decrease and 1% increase',
          'Increasing trend of 1% or greater',
        ]);
        setColours([
          'GREEN',
          'YELLOW',
          'RED',
        ]);
        break;
      case 'amenityCondition':
        setItems([
          'Increasing trend of 1% or greater',
          'Between a 1% decrease and 1% increase',
          'Decreasing trend of 1% or greater',
        ]);
        setColours([
          'GREEN',
          'YELLOW',
          'RED',
        ]);
        break;
      case 'activity':
        if (filter.activity === 'Overall') {
          setItems([
            'Good/Effective',
            'Fit for purpose/developing',
            'Room for Improvement',
            'Unacceptable/basic',
          ]);
          setColours([
            'GREEN',
            'YELLOW',
            'ORANGE',
            'RED',
          ]);
        } else if (filter.activity === 'Smart_buyer_selfassessment') {
          setItems([
            'A Smart Buyer',
            'Developing',
            'Limited',
            'Basic',
          ]);
          setColours([
            'GREEN',
            'YELLOW',
            'ORANGE',
            'RED',
          ]);
        } else {
          setItems([
            'Good',
            'Fit for purpose',
            'Room for Improvement',
            'Not assessed',
          ]);
          setColours([
            'GREEN',
            'YELLOW',
            'ORANGE',
            'GREY',
          ]);
        }
        break;
      case 'coassurance':
        setItems([
          'Effective',
          'Some improvement needed',
          'Significant improvement needed',
          'Unsatisfactory',
        ]);
        setColours([
          'GREEN',
          'YELLOW',
          'ORANGE',
          'RED',
        ]);
        break;
      case 'servicePerformance':
        setItems([
          'Target Achieved',
          'Partially Achieved',
          'Target Not Achieved',
          'Not Reported',
        ]);
        setColours([
          'GREEN',
          'ORANGE',
          'RED',
          'GREY',
        ]);
        break;
      case 'dataQuality':
        setItems([
          '80-100%',
          '70-79%',
          '50-69%',
          '0-49%',
        ]);
        setColours([
          'DQCOLOR4',
          'DQCOLOR3',
          'DQCOLOR2',
          'DQCOLOR1',
        ]);
        break;
      default:
        // nothing
        setColours([]);
        setItems([]);
        break;
    }
  }, [selection, filter]);

  return (
    <Card width="100%" height="auto" padding={2} {...props}>
      <Wrap
        justify="center"
        spacingX={2}
        spacingY={1}
        px={2}
        py={0}
        width="100%"
      >
        {items.map((item, index) => (
          <HStack key={`legend${index}`} align="center">
            <Box backgroundColor={COLOURS[colours[index]]} boxSize={3} borderRadius="full" flexShrink={0} />
            <Text ml={2} mb={0} fontSize="xs">{item}</Text>
          </HStack>
        ))}
      </Wrap>
    </Card>
  );
}

export default MapLegend;
